export default {
  $x年中报: '{{x}}年中报',
  $x年年报: '{{x}}年年报',
  '$x季报（累计）': '{{x}}季报（累计）',
  减持$x: '减持{{x}}',
  减持后剩余$x: '减持后剩余{{x}}',
  增持$x: '增持{{x}}',
  增持后剩余$x: '增持后剩余{{x}}',
  $x年: '{{x}}年',
  截至$x: '截至 {{x}}',
  $x更新: '{{x}}更新',
  $y更新: '{{y}}更新',
  净买入$1: '净买入',
  净买入$2: '净买入',
  查看更多$2: '查看更多',
  '普通股变动(股)$2': '普通股变动(股)',
  年报$2: '年报',
  中报$2: '中报',
  每股收益$2: '每股收益',
  公司名称$2: '公司名称',
  除净日$2: '除净日',
  拆股并股$2: '拆股并股',
  营业利润$2: '营业利润',
  折旧及摊销$2: '折旧及摊销',
  净利率$2: '净利率',
  公布中签$2: '公布中签',
  少数股东权益$2: '少数股东权益',
  持股比例$2: '持股比例',
  总负债$2: '总负债',
  认购$2: '认购',
  暗盘$2: '暗盘',
  净利润$2: '净利润',
  资产净值$2: '资产净值',
  资产负债率$2: '资产负债率',
  非控股权益$2: '非控股权益',
  毛利率$2: '毛利率',
  到期日$2: '到期日',
  $x倍: '{{x}}倍',
  $x年$y季度: '{{x}}年{{y}}季度',
  $x年度: '{{x}}年度',
  基金持仓$2: '基金持仓',
  基金规模$2: '基金规模',
  每股指标$2: '每股指标',
  股东权益$2: '股东权益',
  资产$2: '资产',
  特大$1: '特大',
  大单$1: '大单',
  中单$1: '中单',
  小单$1: '小单'
}
